var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceFemaleInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5C45 29.61 41.702 35.95 36.5525 40.0735C31.937 42.1565 27.816 40.5 22.5 40.5C17.184 40.5 12.68 41.556 8.44751 40.0735C3.298 35.95 0 29.61 0 22.5C0 10.0735 10.0735 0 22.5 0C34.9265 0 45 10.0735 45 22.5Z",
    fill: "#E5E7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5157 35.3845L30.3332 34.1655C28.5052 33.1445 27.1257 31.5395 26.3687 29.6595C26.7912 29.185 27.1797 28.6525 27.5252 28.082C29.0042 27.745 30.4982 27.273 32.0087 26.653C30.8007 25.18 30.3822 24.2295 30.9717 19.802C31.6372 13.467 27.1982 10.159 22.4997 10.0215C17.8012 10.159 13.3622 13.467 14.0277 19.8025C14.6172 24.2295 14.1987 25.1805 12.9907 26.6535C14.5012 27.2735 15.9952 27.7455 17.4742 28.0825C17.8197 28.6525 18.2082 29.1855 18.6307 29.66C17.8732 31.54 16.4942 33.145 14.6662 34.166L12.4837 35.385C10.5982 36.438 9.19167 38.112 8.45117 40.0685C12.3012 43.151 17.1832 44.999 22.4997 44.999C27.8162 44.999 32.6982 43.151 36.5487 40.068C35.8082 38.1115 34.4012 36.4375 32.5157 35.3845Z",
    fill: "#9EA5AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceFemaleInactive);
export default __webpack_public_path__ + "static/media/voice_female_inactive.888388f0e5085427783bb43d6e35d784.svg";
export { ForwardRef as ReactComponent };